import styles from './../styles/footer.module.scss';
import logo from './../img/logo-balvanera.svg';
import instagram from './../img/instagram.svg';
import facebook from './../img/facebook.svg';
import twitter from './../img/twitter.svg';

import React from 'react';
import { Container, Row, Col } from 'reactstrap';

const Footer = (props) => {
  return (
    <Container fluid={true} className={styles.contenedorFooter}>
      <Row className="mx-0">
        <Col xs="12" lg="4" className="px-0">
          <div className="d-flex flex-column justify-content-center align-items-center align-items-lg-start text-left  m-4 px-0 px-lg-4 py-0 py-lg-4 mt-5">
            <p className="text-center text-md-left">
              Carretera libre a Celaya, KM 10 Corregidora, Querétaro, México.
            </p>
            <a href="tel:+442251661" className="text-center text-md-left">
              T.: (442) 225 1661
            </a>
            <p className="text-center text-md-left"> ventas @balvanera.com.mx </p>
            <div className="socialNet">
              <a>
                <img
                  src={twitter}
                  alt="twitter"
                  className={styles.twitter + ' mx-3 lazyload'}
                ></img>
              </a>
              <a>
                <img
                  src={facebook}
                  alt="facebook"
                  className={styles.facebook + ' mx-3 lazyload'}
                ></img>
              </a>
              <a>
                <img
                  src={instagram}
                  alt="instagram"
                  className={styles.instagram + ' mx-3 lazyload'}
                ></img>
              </a>
            </div>
          </div>
        </Col>
        <Col xs="12" lg="4" className="my-4 py-0 py-lg-4 px-0 p-0">
          <img src={logo} alt="logo" className={styles.imgFooter + ' lazyload'}></img>
        </Col>
        <Col xs="12" lg="4" className="my-0 my-lg-5 py-0 py-lg-5 mb-5 p-0 d-none d-md-flex">
          <div className="display-flex text-center  ">
            <a href="#inicio" className="mx-4 w-100">
              INICIO
            </a>
            <a href="#lifestyle" lassName="mx-4 w-100">
              LIFESTYLE
            </a>
            <a href="#ubicacion" className="mx-4 w-100">
              UBICACIÓN
            </a>
          </div>
        </Col>
      </Row>
    </Container>
  );
};
export default Footer;
